/**
 * CVO Dashboard
 * Main dashboard container for Chief Vigilance Officer
 * Handles layout and loads global settings data used across all views
 */

import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { DashboardLayout } from '../views/shared';
import { useSidebar } from '../hooks/useRedux';
import {
  fetchComplaintTypes,
  fetchComplaintStatuses,
  fetchPriorities,
  fetchDepartments,
  fetchDesignations,
  fetchAuthorityPrivileges,
  fetchCVOPrivileges,
} from '../store/slices/settingsSlice';
import { fetchCVODashboard } from '../store/slices/dashboardSlice';

const CVODashboard = () => {
  const dispatch = useDispatch();
  const { isOpen: sidebarOpen, toggle: handleSidebarToggle } = useSidebar();
  
  // Load global settings data and dashboard data on initial mount
  useEffect(() => {
    dispatch(fetchComplaintTypes());
    dispatch(fetchComplaintStatuses());
    dispatch(fetchPriorities());
    dispatch(fetchDepartments());
    dispatch(fetchDesignations());
    dispatch(fetchAuthorityPrivileges());
    dispatch(fetchCVOPrivileges());
    // Fetch CVO dashboard data for dynamic menu
    dispatch(fetchCVODashboard());
  }, [dispatch]);

  return (
    <DashboardLayout
      roleTitle="CVO Portal"
      roleSubtitle="Chief Vigilance Officer"
      useDynamicMenuItems={true}
      sidebarOpen={sidebarOpen}
      onSidebarToggle={handleSidebarToggle}
    >
      <Outlet />
    </DashboardLayout>
  );
};

export default CVODashboard;
